import { ReactComponent as ChevronLeft } from 'assets/chevron-left.svg';
import { useModifiedTranslation } from 'hooks/useModifiedTranslation';

interface BackNavigationButtonProps {
    onClick: () => void;
}

export const BackNavigationButton = ({ onClick }: BackNavigationButtonProps) => {
    const { t } = useModifiedTranslation();
    return (
        <button
            onClick={onClick}
            className='text-2xl font-bold cursor-pointer'
            aria-label={t('component.backNavigation.ariaLabel', { defaultValue: 'Go back' })}
        >
            <ChevronLeft aria-hidden="true" />
        </button>
    );
};
